import { red } from '@mui/material/colors';
import { components } from './components';

const interFontStack = "'Inter var', 'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif";
const headingBase = {
  fontFamily: interFontStack,
  fontWeight: 600,
  lineHeight: 1.2,
};

const themeOptions = {
  typography: {
    htmlFontSize: 16,
    fontSize: 16,
    fontFamily: interFontStack,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    h1: { ...headingBase, fontSize: '2.25rem' },
    h2: { ...headingBase, fontSize: '2rem' },
    h3: { ...headingBase, fontSize: '1.75rem' },
    h4: { ...headingBase, fontSize: '1.5rem' },
    h5: { ...headingBase, fontSize: '1.25rem' },
    h6: { ...headingBase, fontSize: '1.125rem' },
    subtitle1: { fontFamily: interFontStack, fontWeight: 500, fontSize: '1rem' },
    subtitle2: { fontFamily: interFontStack, fontWeight: 500, fontSize: '0.875rem' },
    body1: { fontSize: '1rem', fontFamily: interFontStack, fontWeight: 400 },
    body2: { fontSize: '0.875rem', fontFamily: interFontStack, fontWeight: 400 },
    button: { fontFamily: interFontStack, fontWeight: 600, textTransform: 'none' },
    caption: { fontFamily: interFontStack, fontWeight: 400 },
    overline: { fontFamily: interFontStack, fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.08em' },
  },

  status: { danger: red[500] },
  shape: {
    borderRadius: 0,
  },
  components: { ...components },
};

export default themeOptions;
